export const surveyStatusByRefId = {
  Completed: 1,
  Pending: 2,
  1: 'Completed',
  2: 'Pending',
}
